// extracted by mini-css-extract-plugin
export default {"tabs":"tabs--f1kNH","tab":"tab--UuZPC"};